import Cookies from "js-cookie";
import actions from "./actions";
import { GuestService } from "../../config/data/guestService";
import { DataService } from "../../config/data/dataService";
const {
  initial,
  loginBegin,
  loginSuccess,
  loginErr,
  logoutBegin,
  logoutSuccess,
  logoutErr,
  forgotBegin,
  forgotSuccess,
  forgotErr,
  otpBegin,
  otpSuccess,
  otpErr,
  changeBegin,
  changeSuccess,
  changeErr,
  checkStoreBegin,
  checkStoreSuccess,
  checkStoreErr,
  surveyQuizBegin,
  surveyQuizSuccess,
  surveyQuizErr,
  surveyQuizSkipBegin,
  surveyQuizSkipSuccess,
  surveyQuizSkipErr,
  surveyQuizUpdateTokenBegin,
  surveyQuizUpdateTokenSuccess,
  surveyQuizUpdateTokenErr,
  surveyQuizSubmitBegin,
  surveyQuizSubmitSuccess,
  surveyQuizSubmitErr,
  surveyQuizSnoozed,
  surveyQuizReset,
} = actions;

const SURVEY_SNOOZE_UNTIL_KEY = "survey_snooze_until";

const login = (data) => {
  return async (dispatch) => {
    try {
      dispatch(loginBegin());
      dispatch(surveyQuizReset());
      const response = await GuestService.post("/login", data);
      if (response.status === 200 && response.data.status === true) {
        setTimeout(() => {
          Cookies.set("SangLoggedIn", true, { sameSite: 'strict' });
          Cookies.set("SangLoggedData", JSON.stringify(response.data), { sameSite: 'strict' });
          dispatch(surveyQuizReset());
          dispatch(loginSuccess(true, response.data));
        }, 0);
      } else {
        dispatch(loginErr(response.data.message));
      }
    } catch (err) {
      const errMsg = err?.response?.data?.message || err?.data?.message || err?.message || 'Login failed';
      dispatch(loginErr(errMsg));
    }
  };
};

const sendOtpForgot = (data) => {
  return async (dispatch) => {
    try {
      dispatch(forgotBegin());
      const response = await GuestService.post("/sendForgotOTP", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(forgotSuccess(true, data.username));
      } else {
        dispatch(forgotErr(response.data.message));
      }
    } catch (err) {
      dispatch(forgotErr(err));
    }
  };
};

const verifyOtpForgot = (data) => {
  return async (dispatch) => {
    try {
      dispatch(otpBegin());
      const response = await GuestService.post("/sendVerifiedOTP", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(otpSuccess(true));
      } else {
        dispatch(otpErr(response.data.message));
      }
    } catch (err) {
      dispatch(otpErr(err));
    }
  };
};

const changePassword = (data) => {
  return async (dispatch) => {
    try {
      dispatch(changeBegin());
      const response = await DataService.post("/changePassword", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(changeSuccess(true));
      } else {
        dispatch(changeErr(response.data.message));
      }
    } catch (err) {
      dispatch(changeErr(err));
    }
  };
};

const logOut = () => {
  return async (dispatch) => {
    try {
      dispatch(logoutBegin());
      await GuestService.delete("/logout")
        .then((response) => {
          if (response.data.status === true) {
            Cookies.remove("SangLoggedIn");
            Cookies.remove("SangLoggedData");
            dispatch(surveyQuizReset());
            dispatch(logoutSuccess(true));
          }
        })
        .catch((error) => {
          dispatch(logoutErr(error));
        });
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

const firebaseTokenUpdate = (data) => {
  return async (dispatch) => {
    try {
      await DataService.post("/firebaseTokenUpdate", data);
    } catch (err) {
      // dispatch(loginErr(err));
    }
  };
};

const forgotInitialState = () => {
  return async (dispatch) => {
    dispatch(initial());
  };
};

const checkStorePermission = (router) => {
  return async (dispatch) => {
    try {
      dispatch(checkStoreBegin(router));

      const response = await DataService.post("/checkStore", {
        router,
      });
      if (response?.status === 200 && response?.data) {
        const moduleLock = response.data?.data?.module || {};
        const overallLock = response.data?.data?.overall || {};
        const isOverallLocked = overallLock?.locked_status === "locked";
        const isModuleLocked = moduleLock?.locked_status === "locked";
        const permissionDetails = isOverallLocked ? overallLock : isModuleLocked ? moduleLock : null;
        const lockType = isOverallLocked ? "overall" : isModuleLocked ? "module" : "";
        const message = permissionDetails?.lock_message || response.data?.message;
        const allowed = response.data.status === true && !isOverallLocked && !isModuleLocked;
        const gateMeetingReport = response.data?.data?.gate_meeting_report || "";
        const isTvDownloaded = response.data?.data?.is_tv_panel ?? response.data?.is_tv_panel;
        const isTvDownloadBlocked = isTvDownloaded === true || isTvDownloaded === 'true';

        dispatch(checkStoreSuccess(allowed, router, lockType, message, permissionDetails, gateMeetingReport, isTvDownloaded));
        return allowed && !isTvDownloadBlocked;
      } else {
        dispatch(
          checkStoreErr(response?.data?.message || "Permission check failed", router)
        );
        return false;
      }
    } catch (err) {
      const errPayload = err?.response?.data?.message || err?.response?.data || err?.message || err;
      dispatch(checkStoreErr(errPayload, router));
      return false;
    }
  };
};

const checkSurveyQuiz = (uniqueToken, router) => {
  return async (dispatch) => {
    try {
      dispatch(surveyQuizBegin(router));

      const response = await DataService.post("/checkSurveyQuiz", {
        unique_token: uniqueToken,
      });

      if (response?.status === 200 && response?.data) {
        const quizData = response.data?.data?.data || {};
        const questions = Array.isArray(quizData?.getQuizQuestionList)
          ? quizData.getQuizQuestionList
          : [];
        const isProcessing = quizData?.checkAlreadyAttend === "Processing";
        const isPending = quizData?.checkAlreadyAttend === "Pending";
        const required = response.data?.status === true && isPending && questions.length > 0;
        const processing = response.data?.status === true && isProcessing;

        dispatch(
          surveyQuizSuccess(
            {
              required,
              processing,
              surveyId: quizData?.surveyId,
              questions,
              checkAlreadyAttend: quizData?.checkAlreadyAttend,
              displayMesssage: quizData?.displayMesssage,
              snoozeLimit: quizData?.snoozeLimit,
              snoozedCount: quizData?.snoozedCount,
              isSkippable: quizData?.isSkippable,
              message: quizData?.displayMesssage || response.data?.message,
            },
            router,
            uniqueToken
          )
        );
        return response.data;
      }

      dispatch(surveyQuizErr(response?.data?.message || "Survey quiz check failed", router));
      return response?.data;
    } catch (err) {
      const errPayload = err?.response?.data?.message || err?.response?.data || err?.message || err;
      dispatch(surveyQuizErr(errPayload, router));
      return false;
    }
  };
};

const skipSurveyQuiz = (uniqueToken, surveyId, router) => {
  return async (dispatch) => {
    try {
      dispatch(surveyQuizSkipBegin());

      const response = await DataService.post("/skipSurveyQuiz", {
        quiz_survey_id: surveyId,
        unique_token: uniqueToken,
      });

      if (response?.status === 200 && response?.data?.status === true) {
        localStorage.setItem(SURVEY_SNOOZE_UNTIL_KEY, String(Date.now() + 60000));
        dispatch(surveyQuizSkipSuccess(response.data));
        return response.data;
      }

      dispatch(surveyQuizSkipErr(response?.data?.message || "Survey quiz skip failed"));
      return response?.data;
    } catch (err) {
      const errPayload = err?.response?.data?.message || err?.response?.data || err?.message || err;
      dispatch(surveyQuizSkipErr(errPayload));
      return false;
    }
  };
};

const updateSurveyQuizToken = (uniqueToken, surveyId, router) => {
  return async (dispatch) => {
    try {
      dispatch(surveyQuizUpdateTokenBegin());

      const response = await DataService.post("/updateSurveyQuizToken", {
        quiz_survey_id: surveyId,
        unique_token: uniqueToken,
      });

      if (response?.status === 200 && response?.data?.status === true) {
        dispatch(surveyQuizUpdateTokenSuccess(response.data));
        dispatch(checkSurveyQuiz(uniqueToken, router));
        return response.data;
      }

      dispatch(surveyQuizUpdateTokenErr(response?.data?.message || "Survey quiz token update failed"));
      return response?.data;
    } catch (err) {
      const errPayload = err?.response?.data?.message || err?.response?.data || err?.message || err;
      dispatch(surveyQuizUpdateTokenErr(errPayload));
      return false;
    }
  };
};

const submitSurveyQuiz = (uniqueToken, surveyId, quizData) => {
  return async (dispatch) => {
    try {
      dispatch(surveyQuizSubmitBegin());

      const response = await DataService.post("/submitSurveyQuiz", {
        quizSurveyId: surveyId,
        quizData: typeof quizData === "string" ? quizData : JSON.stringify(quizData || {}),
        unique_token: uniqueToken,
      });

      if (response?.status === 200 && response?.data?.status === true) {
        dispatch(surveyQuizSubmitSuccess(response.data));
        return response.data;
      }

      const errors = response?.data?.errors || {};
      const errPayload = Object.keys(errors).length > 0
        ? Object.values(errors).join(", ")
        : response?.data?.message || "Survey quiz submit failed";
      dispatch(surveyQuizSubmitErr(errPayload));
      return response?.data;
    } catch (err) {
      const errPayload = err?.response?.data?.message || err?.response?.data || err?.message || err;
      dispatch(surveyQuizSubmitErr(errPayload));
      return false;
    }
  };
};

const markSurveyQuizSnoozed = (uniqueToken, router) => {
  return async (dispatch) => {
    dispatch(surveyQuizSnoozed(router, uniqueToken));
  };
};

export {
  login,
  logOut,
  firebaseTokenUpdate,
  sendOtpForgot,
  verifyOtpForgot,
  changePassword,
  forgotInitialState,
  checkStorePermission,
  checkSurveyQuiz,
  skipSurveyQuiz,
  updateSurveyQuizToken,
  submitSurveyQuiz,
  markSurveyQuizSnoozed,
};
